import api from "./api";

class PermessiManager {
    permessi(config?: any) {
        return api.get(`/permissions`, config)
    }
    permesso(id: number | string) {
        return api.get(`/permissions/${id}`)

    }
    list = this.permessi
    retrieve = this.permesso
    paginatedList = this.permessi
}

const permessiManager = new PermessiManager()

export default permessiManager
